import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import * as Yup from "yup";
import {TranslateContext} from "../../context/TranslateContext";
import {
    aggiornaClasseTipoImpExpDatiApi, aggiungiClasseTipoImpExpDatiApi,
    getClasseTipiImpExpDatiByIdApi
} from "./services/TipiImpExpDatiServices";
import ModificaClasseImpExpView from "./ModificaClasseImpExpView";

export default function ModificaClasseImpExpController() {
    const {id} = useParams()

    const iconaDefault = 'fas fa-building';

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getClassiOrg() {
        const response = await getClasseTipiImpExpDatiByIdApi(id);
        setLoadingData(false);

        if (formikRef.current) {
            formikRef.current.setFieldValue("id_classe_tipo_imp_exp", response.data.data.id_classe_tipo_imp_exp)
            formikRef.current.setFieldValue("codice", response.data.data.codice)
            formikRef.current.setFieldValue("descrizione", response.data.data.descrizione)
            formikRef.current.setFieldValue("canc", response.data.data.canc)
            formikRef.current.setFieldValue("icona", response.data.data.icona)
        }
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getClassiOrg();
            }
        }
    }, []);

    const SignupSchema = Yup.object().shape({
        codice: Yup.string()
            .max(20, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        descrizione: Yup.string()
            .max(200, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
    });

    async function aggiornaClasseTipoImpExpDati(values) {
        const response = await aggiornaClasseTipoImpExpDatiApi(id, values);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiClasseTipoImpExpDati(values) {
        const response = await aggiungiClasseTipoImpExpDatiApi(values);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    const initialValuesForm = {
        id_classe_tipo_imp_exp: '',
        codice: '',
        descrizione: '',
        canc: '',
        icona: iconaDefault
    };

    function onSubmitForm(values) {
        if (id) {
            aggiornaClasseTipoImpExpDati(values);
        } else {
            aggiungiClasseTipoImpExpDati(values);
        }
    }

    return (
        <ModificaClasseImpExpView
            formikRef={formikRef}
            show={show}
            id={id}
            setShow={setShow}
            SignupSchema={SignupSchema}
            modalMsg={modalMsg}
            iconaDefault={iconaDefault}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            initialValuesForm={initialValuesForm}
            onSubmitForm={onSubmitForm}
        />
    );
}